import { useState } from "react";
import { LeftSideMenu } from "../../components/leftSideMenu/LeftSideMenu";
import { TabbedContent } from "../../components/tabs/TabbedContent";
import {
  CreationForm,
  CreationFormTemplate,
} from "../../components/form/CreationForm";
import DragDropInput from "../../components/form/DragDropInput";
import DataTable from "../../components/dataTables/DataTable";
import {
  useMedia,
  useMediaProduct,
  useProduct,
  useProducts,
} from "../../hooks";
import { buildColDefs } from "../../components/dataTables/buildColDefs";
import { fileToDataURL } from "../../data-parsing/parseUtils";
import { AddProductFormTemplate } from "../../data-parsing/products/AddProductFormTemplate";
import { Product } from "../../data-parsing/products/Product";

export function Products() {
  const [query, setQuery] = useState(null);
  const { products, createProduct, deleteProduct } = useProducts(query);
  const { updateProduct } = useProduct();
  const colDefs = buildColDefs(Product);
  const { createMediaProduct } = useMediaProduct("webStore/", "");

  const afterSubmit = (newElement, parsedFormData) => {
    fileToDataURL(
      newElement?._id,
      parsedFormData[0][`thumbnail`],
      "",
      createMediaProduct,
      true,
      "Image"
    );
    //TODO: MAYBE MULTIPLE PHOTOS CAN BE ADDED, SO ITERATE ON ELEMENTS IN PARSEDFORMDATA FOR THE IMAGES
    if (parsedFormData[0][`video`] && parsedFormData[0][`video`].size) {
      fileToDataURL(
        newElement?._id,
        parsedFormData[0][`video`],
        "",
        createMediaProduct,
        false,
        "Video"
      );
    }
  };

  return (
    <LeftSideMenu active="products">
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <div className="card-box card-tabs m-t-20">
              <h4 className="header-title m-t-0 m-b-30 pull-right">
                PRODUCTOS
              </h4>
              <TabbedContent
                tabHeaders={[
                  <button data-toggle="tab" aria-expanded="true">
                    <i className="fas fa-plus-circle"></i> NUEVO PRODUCTO
                  </button>,
                  <button
                    data-toggle="tab"
                    aria-expanded="false"
                    onClick={() => setQuery(0)}
                  >
                    <i className="far fa-eye"></i> LISTAR PRODUCTOS
                  </button>,
                ]}
              >
                <div className="fade in ">
                  <div className="row">
                    <CreationForm
                      createFunction={createProduct}
                      afterSubmit={afterSubmit}
                    >
                      <div className="col-md-5">
                        <div className="form-group">
                          <label>Imagen</label>
                          <DragDropInput
                            fileTypes={["JPG", "PNG", "GIF"]}
                            name={"thumbnail"}
                            style={{ height: "350px" }}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label>Vídeo</label>
                          <DragDropInput
                            fileTypes={["MP4", "WEBM"]}
                            name={"video"}
                            style={{ height: "350px" }}
                          />
                        </div>
                      </div>

                      <CreationFormTemplate
                        formTemplate={AddProductFormTemplate}
                        dataTemplate={Product}
                      />

                      <div className="col-sm-12">
                        <button className="btn btn-rounded btn-purple m-t-20 ml-10">
                          <i className="far fa-save"></i> Guardar Producto
                        </button>
                      </div>
                    </CreationForm>
                  </div>
                </div>

                <div className="fade in">
                  <DataTable
                    data={products}
                    colDefs={colDefs}
                    dataId={"Products"}
                    scrollX={false}
                    allowHiddenColumns={true}
                    dataTemplate={Product}
                    resizable={true}
                    className="table table-bordered panel-group"
                    editElement={updateProduct}
                    deleteElement={deleteProduct}
                  />
                </div>
              </TabbedContent>
            </div>
          </div>
        </div>
      </div>
    </LeftSideMenu>
  );
}
export default Products;
